import translations from "@/../translations/translations.json";
import { createGettext } from "vue3-gettext";

export const gettext = createGettext({
  availableLanguages: {
    en_US: "English"
  },
  defaultLanguage: import.meta.env.VITE_LANGUAGE || "en_US",
  translations: translations,
  silent: true
})
export default function (app) {
  app.use(gettext)
}
